<script setup>
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";
import {inject, onMounted, ref} from "vue";
import startupsService from "@/services/startups.service";
import aiSequencesService from "@/services/ai-squences.service";
import Loader from "@/components/ui/PulseLoader.vue";

const props = defineProps(['fields']);
const emit = defineEmits(['fields']);

const companyId = inject('companyId');
const customFieldsFeedbacks = inject('customFieldsFeedbacks');
const setCustomFieldFeedback = inject('setCustomFieldFeedback');

const loading = ref(false);
const requested = ref(false);
const loadLabels = ref([]);
const loadLabel = ref('');

onMounted(() => {
    getLoadLabels();
})

async function getLoadLabels() {
    const {data} = await aiSequencesService.getLoadingText('trl_score_fields');
    loadLabels.value = data;
}

async function getFields() {
    loading.value = true;
    let result = {};

    for (let index in loadLabels.value) {
        loadLabel.value = loadLabels.value[index];

        let {data} = await startupsService.getTrlFields(companyId, parseInt(index) + 1);
        result = data;

        if (!Object.keys(result).some(fieldId => !result[fieldId])) {
            break;
        }
    }

    let updatedFields = [...props.fields];

    Object.keys(result).forEach(fieldId => {
        const field = updatedFields.find(item => item.id === parseInt(fieldId));

        if (field) {
            field.value.text = result[fieldId];
        }
    });

    loading.value = false;
    requested.value = true;
    emit('update:fields', updatedFields);
}

</script>

<template>
    <tbody>
    <tr v-for="field in fields" :key="field.id" class="trl">
        <td>
            {{field.name}}

            <div v-if="(field.value.text || requested)">
                <a v-if="!loading && loadLabels.length" class="link" @click="getFields">
                    Reload
                </a>
            </div>
        </td>

        <td>
            <Loader
                v-if="loading"
                :label="loadLabel"
            />

            <template v-else>
                <CustomFieldValue
                    v-if="field.value.text"
                    :field="field"
                    :init-value="field.value"
                    :editable="false"
                />
                <div v-else>
                    <span v-if="requested">
                        Not Available
                    </span>

                    <a v-else-if="!loading && loadLabels.length" class="link" @click="getFields">
                        Load
                    </a>
                </div>
            </template>
        </td>

        <td>
            <div class="opinion">
                <span class="opinion__question">Helpful?</span>

                <span class="opinion__positive">
                    <input :disabled="!!customFieldsFeedbacks[field.id]" type="radio" :id="'opinion–' + field.id + '-yes'" value="yes"
                           @click="() => setCustomFieldFeedback(field.id, 'yes')" v-model="customFieldsFeedbacks[field.id]"
                    />
                    <label :for="'opinion–' + field.id + '-yes'"></label>
                </span>

                <span class="opinion__negative">
                    <input :disabled="!!customFieldsFeedbacks[field.id]" type="radio" :id="'opinion–' + field.id + '-no'" value="no"
                           @click="() => setCustomFieldFeedback(field.id, 'no')" v-model="customFieldsFeedbacks[field.id]"
                    />
                    <label :for="'opinion–' + field.id + '-no'"></label>
                </span>
            </div>
        </td>
    </tr>
    </tbody>
</template>

<style scoped>

</style>
